import axios from '@/components/api/axios';

async function getNewRegistration() {
  const res = await axios.axiosGet('/api/campaign/getNewRegistration', null);
  return res;
}

async function entryNewRegistration(campaignCode) {
  let data = {
    campaignCode: campaignCode
  }
  const res = await axios.axiosPost('/api/campaign/entryNewRegistration', data);
  return res;
}


export default {
  getNewRegistration,
  entryNewRegistration
}



// WEBPACK FOOTER //
// ./src/components/api/campaign/newRegistration.js